(function () {
  if (window.__NO_GLASS_DEDUCTION_SAFE_V10_SHARED__) return;
  window.__NO_GLASS_DEDUCTION_SAFE_V10_SHARED__ = true;

  window.NO_GLASS_DEBUG_MODE = false;

  /*
    =========================================================
    共用規則：
    1. 由 path / 頁面文字 判斷 doorType
    2. 再由 NO_GLASS_DEDUCTION_MAP 自動反查 category
    3. 查表路徑固定：
       NO_GLASS_DEDUCTION_MAP[category][doorType][size][panelType]
    =========================================================
  */

  /*
    這裡只負責「網址 / handle -> doorType」對照
    之後如果新增新門款，只要補這裡 + mapping 表
  */
  const NO_GLASS_ROUTE_MAP = [
    // hinged
    { doorType: 'single_hinged', patterns: ['single-hinged', 'single_hinged'] },
    { doorType: 'double_hinged', patterns: ['double-hinged', 'double_hinged'] },
    { doorType: 'center_hinged', patterns: ['center-hinged', 'center_hinged'] },
    { doorType: 'vented_sidelight', patterns: ['vented-sidelight', 'vented_sidelight', 'venting-sidelight', 'venting_sidelight'] },

    // new hinged
    { doorType: 'folding', patterns: ['folding-door', 'folding_door', 'folding'] },

    // new gliding
    { doorType: 'gliding_bypass', patterns: ['bypass-gliding-door', 'bypass_gliding_door', 'gliding-bypass', 'gliding_bypass', 'bypass-gliding', 'bypass_gliding'] }
  ];

  function getCurrentPath() {
    return (location.pathname || '').toLowerCase();
  }

  function getPageText() {
    return (
      document.querySelector('main')?.innerText ||
      document.body?.innerText ||
      ''
    ).toLowerCase();
  }

  function buildDoorTypeCategoryMap() {
    const out = {};
    const map = window.NO_GLASS_DEDUCTION_MAP || {};

    Object.keys(map).forEach(category => {
      const categoryMap = map[category] || {};
      Object.keys(categoryMap).forEach(doorType => {
        out[doorType] = category;
      });
    });

    return out;
  }

  function getCategoryByDoorType(doorType) {
    const table = buildDoorTypeCategoryMap();
    return table[doorType] || '';
  }

  function normalizeDoorSize(raw) {
    if (!raw) return '';

    let text = String(raw).toLowerCase().trim();
    text = text.replace(/[’']/g, '');
    text = text.replace(/[”"]/g, '');
    text = text.replace(/\s+/g, '');

    let m = text.match(/\b(\d{4,6})\b/);
    if (m) return m[1];

    m = text.match(/(\d{1,2})[-\/]?(\d)x(\d)[-\/]?(\d{1,2})/i);
    if (m) return `${m[1]}${m[2]}${m[3]}${m[4]}`;

    return '';
  }

  function detectHingedDoorTypeFromText() {
    const text = getPageText();

    if (/folding\s*door/.test(text)) {
      return 'folding';
    }

    return '';
  }

  function detectGlidingDoorTypeFromText() {
    const text = getPageText();

    if (!/gliding/.test(text)) return '';

    // Bypass Gliding Door
    if (/bypass\s*gliding\s*door/.test(text)) {
      return 'gliding_bypass';
    }

    if (/gliding\s*door\s*-\s*4\s*panels/.test(text)) {
      return 'gliding_4_panel';
    }

    if (/gliding\s*door\s*-\s*3\s*panels/.test(text)) {
      return 'gliding_3_panel';
    }

    if (/gliding\s*door\s*-\s*2\s*panels/.test(text)) {
      return 'gliding_2_panel';
    }

    return '';
  }

  function detectFixedDoorTypeFromText() {
    const text = getPageText();

    if (!/fixed/.test(text)) return '';

    if (/fixed\s*\(?\s*gliding\s*\)?\s*-\s*1\s*panel/.test(text)) {
      return 'gliding_one_panel';
    }

    if (/fixed\s*-\s*3\s*panels/.test(text)) {
      return 'hinged_three_panel';
    }

    if (/fixed\s*-\s*2\s*panels/.test(text)) {
      return 'hinged_two_panel';
    }

    if (/fixed\s*-\s*1\s*panel/.test(text)) {
      return 'hinged_one_panel';
    }

    return '';
  }

  function detectDoorTypeFromPath() {
    const path = getCurrentPath();

    // 1. 先吃 path 規則
    for (const rule of NO_GLASS_ROUTE_MAP) {
      const hit = (rule.patterns || []).some(p => path.includes(String(p).toLowerCase()));
      if (hit) return rule.doorType;
    }

    // 2. hinged 類特殊頁面文字判斷
    const hingedDoorType = detectHingedDoorTypeFromText();
    if (hingedDoorType) return hingedDoorType;

    // 3. gliding 類頁面文字判斷
    const glidingDoorType = detectGlidingDoorTypeFromText();
    if (glidingDoorType) return glidingDoorType;

    // 4. fixed 類頁面文字判斷
    const fixedDoorType = detectFixedDoorTypeFromText();
    if (fixedDoorType) return fixedDoorType;

    return '';
  }

  function getDoorMetaFromPath() {
    const doorType = detectDoorTypeFromPath();
    const category = getCategoryByDoorType(doorType);
    return { category, doorType };
  }

  function isSupportedNoGlassPage() {
    const { category, doorType } = getDoorMetaFromPath();
    return !!window.NO_GLASS_DEDUCTION_MAP?.[category]?.[doorType];
  }

  function getCheckedInputs() {
    return Array.from(
      document.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')
    );
  }

  function getInputJoinedText(input) {
    return [
      input.value || '',
      input.getAttribute('value') || '',
      input.getAttribute('data-label') || '',
      input.getAttribute('aria-label') || '',
      input.closest('label')?.textContent || '',
      input.parentElement?.textContent || '',
      input.nextSibling?.textContent || ''
    ].join(' ').toLowerCase();
  }

  function getSelectedNoGlassState() {
    return getCheckedInputs().some(input => /no\s*glass/.test(getInputJoinedText(input)));
  }

  function getSelectedDoorSize() {
    const checked = getCheckedInputs();

    for (const input of checked) {
      const m = String(input.value || '').match(/\b\d{4,6}\b/);
      if (m) return normalizeDoorSize(m[0]);
    }

    for (const input of checked) {
      const texts = [
        input.getAttribute('value') || '',
        input.getAttribute('data-label') || '',
        input.getAttribute('aria-label') || '',
        input.closest('label')?.textContent || '',
        input.parentElement?.textContent || '',
        input.nextSibling?.textContent || ''
      ];

      for (const raw of texts) {
        const m = String(raw || '').match(/\b\d{4,6}\b/);
        if (m) return normalizeDoorSize(m[0]);
      }
    }

    return '';
  }

  function getSelectedPanelType() {
    const checked = getCheckedInputs();

    for (const input of checked) {
      const joined = getInputJoinedText(input);

      if (/3\s*\/\s*4\s*lite|3\/4\s*lite|3\s*4\s*lite|three\s*quarter\s*lite/.test(joined)) {
        return 'three_quarter_lite';
      }

      if (/full\s*view|full\s*lite/.test(joined)) {
        return 'full_lite';
      }
    }

    return '';
  }

  function getDoorMap() {
    const { category, doorType } = getDoorMetaFromPath();
    return window.NO_GLASS_DEDUCTION_MAP?.[category]?.[doorType] || null;
  }

  function getNoGlassDeductionAmount() {
    if (!isSupportedNoGlassPage()) return 0;
    if (!getSelectedNoGlassState()) return 0;

    const { category, doorType } = getDoorMetaFromPath();
    const size = getSelectedDoorSize();
    const panelType = getSelectedPanelType();

    if (!category || !doorType || !size || !panelType) return 0;

    return Number(
      window.NO_GLASS_DEDUCTION_MAP?.[category]?.[doorType]?.[size]?.[panelType] || 0
    );
  }

  function getNoGlassContext() {
    const meta = getDoorMetaFromPath();
    const size = getSelectedDoorSize();
    const panelType = getSelectedPanelType();
    const doorMap = getDoorMap();

    return {
      category: meta.category,
      doorType: meta.doorType,
      selected: getSelectedNoGlassState(),
      size,
      panelType,
      deduction: getNoGlassDeductionAmount(),
      availableSizes: Object.keys(doorMap || {}),
      availablePanelTypesForSize: Object.keys((doorMap && size && doorMap[size]) || {})
    };
  }

  function renderNoGlassDeductionLine() {
    if (!isSupportedNoGlassPage()) return;

    const deduction = getNoGlassDeductionAmount();
    const checked = getCheckedInputs();

    const noGlassInput = checked.find(input => /no\s*glass/.test(getInputJoinedText(input)));
    if (!noGlassInput) return;

    let row = noGlassInput.parentElement;
    while (row && row !== document.body) {
      const text = (row.textContent || '').toLowerCase();
      if (/no\s*glass/.test(text)) break;
      row = row.parentElement;
    }

    if (!row || row === document.body) return;

    row.style.position = 'relative';
    row.style.minHeight = '28px';

    let badge = row.querySelector('.no-glass-credit-inline');

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'no-glass-credit-inline';
      badge.style.position = 'absolute';
      badge.style.left = '110px';
      badge.style.top = '50%';
      badge.style.transform = 'translateY(-50%)';
      badge.style.color = '#c62828';
      badge.style.fontWeight = '700';
      badge.style.fontSize = '14px';
      badge.style.whiteSpace = 'nowrap';
      row.appendChild(badge);
    }

    if (deduction > 0) {
      badge.textContent = `-$${deduction.toFixed(2)}`;
      badge.style.display = 'inline-block';
    } else {
      badge.style.display = 'none';
    }
  }

  function getCartAddForms() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
  }

  function getBssCustomAttrsInput(form) {
    return form.querySelector('input[name="properties[__bssCustomAttrs]"]');
  }

  function safeParseJson(str) {
    if (!str) return {};
    try {
      return JSON.parse(str);
    } catch (e) {
      return {};
    }
  }

  function syncNoGlassToBssCustomAttrs() {
    const forms = getCartAddForms();
    if (!forms.length) return;

    const ctx = getNoGlassContext();

    forms.forEach(form => {
      const bssInput = getBssCustomAttrsInput(form);
      if (!bssInput) return;

      const attrs = safeParseJson(bssInput.value);

      if (ctx.selected) {
        attrs['No Glass Selected'] = 'Yes';
        attrs['No Glass Deduction'] = `-${ctx.deduction || 0}`;
        attrs['No Glass Category'] = ctx.category || '';
        attrs['No Glass Door Type'] = ctx.doorType || '';
        attrs['No Glass Door Size'] = ctx.size || '';
        attrs['No Glass Panel Type'] = ctx.panelType || '';
      } else {
        delete attrs['No Glass Selected'];
        delete attrs['No Glass Deduction'];
        delete attrs['No Glass Category'];
        delete attrs['No Glass Door Type'];
        delete attrs['No Glass Door Size'];
        delete attrs['No Glass Panel Type'];
      }

      bssInput.value = JSON.stringify(attrs);
    });

    if (window.NO_GLASS_DEBUG_MODE) {
      console.log('[NoGlass][sync BSS attrs]', {
        formCount: forms.length,
        ctx,
        values: forms.map(form => ({
          id: form.id,
          bss: getBssCustomAttrsInput(form)?.value || '(missing)'
        }))
      });
    }
  }

  function getAddToCartButtons() {
    return Array.from(document.querySelectorAll('button, input[type="submit"]')).filter(el => {
      const txt = (el.innerText || el.value || '').trim().toLowerCase();
      return txt.includes('add to cart');
    });
  }

  function attachClickHooks() {
    const buttons = getAddToCartButtons();

    buttons.forEach(btn => {
      if (btn.dataset.noGlassClickHooked === '1') return;
      btn.dataset.noGlassClickHooked = '1';

      btn.addEventListener('click', function () {
        syncNoGlassToBssCustomAttrs();
        setTimeout(syncNoGlassToBssCustomAttrs, 0);
        setTimeout(syncNoGlassToBssCustomAttrs, 50);
        setTimeout(syncNoGlassToBssCustomAttrs, 150);

        if (window.NO_GLASS_DEBUG_MODE) {
          console.log('[NoGlass][click add to cart]', getNoGlassContext());
        }
      }, true);
    });
  }

  function attachSubmitHooks() {
    const forms = getCartAddForms();

    forms.forEach(form => {
      if (form.dataset.noGlassHooked === '1') return;
      form.dataset.noGlassHooked = '1';

      form.addEventListener('submit', function () {
        syncNoGlassToBssCustomAttrs();
        setTimeout(syncNoGlassToBssCustomAttrs, 0);

        if (window.NO_GLASS_DEBUG_MODE) {
          const bssInput = getBssCustomAttrsInput(form);
          console.log('[NoGlass][submit __bssCustomAttrs]', bssInput ? bssInput.value : '(missing)');
        }
      }, true);
    });
  }

  function refreshNoGlass() {
    if (!isSupportedNoGlassPage()) return;

    renderNoGlassDeductionLine();
    syncNoGlassToBssCustomAttrs();
    attachClickHooks();
    attachSubmitHooks();

    if (window.NO_GLASS_DEBUG_MODE) {
      console.log('[NoGlass]', getNoGlassContext());
    }
  }

  document.addEventListener('change', function () {
    setTimeout(refreshNoGlass, 120);
    setTimeout(refreshNoGlass, 350);
    setTimeout(refreshNoGlass, 700);
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(refreshNoGlass, 300);
    setTimeout(refreshNoGlass, 900);
    setTimeout(refreshNoGlass, 1500);
  });

  window.refreshNoGlassDebug = refreshNoGlass;
  window.getNoGlassContext = getNoGlassContext;
  window.getSelectedDoorSize = getSelectedDoorSize;
  window.getSelectedPanelType = getSelectedPanelType;
  window.getSelectedNoGlassState = getSelectedNoGlassState;
  window.getNoGlassDeductionAmount = getNoGlassDeductionAmount;
  window.getNoGlassDoorMeta = getDoorMetaFromPath;
  window.getNoGlassCategoryByDoorType = getCategoryByDoorType;
  window.NO_GLASS_ROUTE_MAP = NO_GLASS_ROUTE_MAP;
})();